/**
 * Placeholder messages for form inputs
 * Centralized placeholders for reusability and easy maintenance
 */

export const PLACEHOLDER_MESSAGES = {
  // Postal Code
  POSTAL_CODE_3_DIGITS: '3桁',
  POSTAL_CODE_4_DIGITS: '4桁',

  // Company Information
  GALI_CODE_INPUT: 'Gali取引先コードを入力',
  OFFICIAL_NAME_INPUT: '正式名称を入力',
  ABBREVIATED_NAME_INPUT: '略称（簡易名称）を入力',
  BRANCH_DEPARTMENT_INPUT: '支店・部門を入力',
  COMPANY_NAME_KATAKANA_INPUT: '取引先名カナ(半角ｶﾅ)を入力',

  // Address
  ADDRESS1_INPUT: '住所１を入力',
  ADDRESS2_INPUT: '住所２を入力',
  ADDRESS3_INPUT: '住所３を入力',
  FACTORY_ADDRESS_INPUT: '工場所在地を入力',

  // Contact Information
  PHONE_INPUT: '電話番号を入力',
  FAX_INPUT: 'FAX番号を入力',
  EMAIL_INPUT: 'メールアドレスを入力',
  CONTACT_PERSON_INPUT: '担当者を入力',
  DEPARTMENT_INPUT: '部署を入力',
  NAME_INPUT: '氏名を入力',

  // Factory
  FACTORY_NAME_INPUT: '工場を入力',

  // Numbers (Half-width)
  COUNT_INPUT_HALF_WIDTH: '台数を入力してください（半角数値）',
  PERSONNEL_COUNT_INPUT_HALF_WIDTH: '取得者数を入力してください（半角数値）',

  // Mixer Information
  RATED_CAPACITY_INPUT: '公称能力を入力',
  TYPE_INPUT: '形式を入力',
  CAPACITY: '容量',
  CARDINALITY: '基数',
  MANUFACTURER_INPUT: '製作会社を入力',
  MEASUREMENT_METHOD_INPUT: '計量方式を入力',

  // Raw Materials
  MANUFACTURER_ORIGIN_INPUT: 'メーカーを入力',
  MATERIAL_TYPE_INPUT: '種類を入力',
  ORIGIN_INPUT: '産地を入力',

  // Union Membership
  INDUSTRIAL_UNION_INPUT: '加盟工業組合を入力',
  COOPERATIVE_UNION_INPUT: '加盟協同組合を入力',

  // Certifications
  JIS_NUMBER_INPUT: '日本工業規格認証番号を入力',
  CERTIFICATION_TYPE_INPUT: '認証の区分を入力',
  HIGH_STRENGTH_NUMBER_INPUT: '高強度大臣認定番号を入力',
} as const;
